import { isEmpty } from 'ramda';
import { useCallback } from 'react';
import { useParams } from 'react-router';

import { useAppDispatch, useAppSelector } from '@/shared/hooks';
import { scrollToElementByID } from '@/shared/lib';
import { Skeleton } from '@/shared/ui';

import { reportsModel } from '@/entities/reports';

import {
  ToothChart,
  toothChartModel,
  ToothChartItemClickHandler,
} from '@/features/toothChart';

import styles from './GpFDAToothChart.module.scss';

export const GpFDAToothChart = () => {
  const { reportID } = useParams();
  const dispatch = useAppDispatch();

  const { toothItems, toothTypesSet, isFDA3DGPRestrictions } = useAppSelector(
    toothChartModel.selectors.selectToothChartItems(reportID as string),
  );

  const isToothChartReady = !isEmpty(toothTypesSet);

  const handleToothClick = useCallback<ToothChartItemClickHandler>(
    ({ id, active }) => {
      if (active) {
        scrollToElementByID(id);
        dispatch(reportsModel.actions.setActiveToothID(id));
      }
    },
    [dispatch],
  );

  return (
    <ToothChart.Root size="default" className={styles.container}>
      <ToothChart.Header></ToothChart.Header>

      {isToothChartReady ? (
        <>
          <ToothChart.Tags
            toothTypesSet={toothTypesSet}
            reportID={reportID as string}
            isFDAMode={isFDA3DGPRestrictions}
          />

          <ToothChart.Grid>
            {toothItems.map((toothItem) => (
              <ToothChart.MetaItem
                showApprovedStatus
                key={toothItem.id}
                toothItem={toothItem}
                handleToothClick={handleToothClick}
              />
            ))}
          </ToothChart.Grid>
        </>
      ) : (
        <>
          <Skeleton.Filter
            filtersQuantity={4}
            height={20}
            gap={4}
            borderRadius={10}
          />

          <Skeleton width={582} height={184} borderRadius={8} />
        </>
      )}
    </ToothChart.Root>
  );
};
